import React, { useEffect, useMemo, useState } from 'react';
import { EnrichedTagsLayout, TagsLayout } from '../types';
import { buildEnrichedTagsLayout } from '../utils/buildEnrichedTagsLayout';

interface UseParentWidthProps {
    parentRef: React.RefObject<HTMLElement>;
    tagsLayout: TagsLayout;
    numOfLines: number;
}

interface UseParentWidthResult {
    parentWidth: number;
    containerHeight: number;
    enrichedTagsLayout: EnrichedTagsLayout;
}

export const useParentWidth = ({ parentRef, tagsLayout, numOfLines }: UseParentWidthProps): UseParentWidthResult => {
    const [parentWidth, setParentWidth] = useState<number>(0);
    const enrichedTagsLayout = useMemo(() => buildEnrichedTagsLayout(tagsLayout), [tagsLayout]);

    useEffect(() => {
        if (parentRef.current) {
            setParentWidth(parentRef.current.offsetWidth);
        }
    }, [parentRef]);

    const containerHeight = useMemo(
        () => enrichedTagsLayout.tagLineHeightPx * numOfLines + enrichedTagsLayout.gapSizePx * (numOfLines - 1),
        [enrichedTagsLayout.gapSizePx, enrichedTagsLayout.tagLineHeightPx, numOfLines]
    );

    return {
        parentWidth,
        containerHeight,
        enrichedTagsLayout,
    };
};
